<template>
  <div>
    <add-cashout-method :is-active.sync="isAdding" @changed="paymentCashoutAdded" />
    <data-table
      title="Transfer Payout Methods"
      :url="url"
      :headers="headers"
      :fields="fields"
      ref="table"
      searchable
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add Payout Method
        </v-btn>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddCashoutMethod from "./form";

export default {
  components: { AddCashoutMethod },
  data() {
    return {
      isAdding: false,
      url: "/api/v1/transactions/transferCashoutMethods",
      headers: {
        name: "Name",
        type: "Type",
        "payment_provider.name": "Provider",
        min_amount: "Min Amount",
        max_amount: "Max Amount",
      },
      fields: {
        min_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
        max_amount: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    paymentCashoutAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    showDetails({ id }) {
      this.$router.push({ name: "platform.cashoutMethods.show", params: { id } });
    },
  },
};
</script>
